"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicType = void 0;
var tslib_1 = require("tslib");
var binding_1 = require("../binding");
var GeoPoint_1 = require("../GeoPoint");
var Type_1 = require("./Type");
function dateToJson(value) {
    // remove trailing zeros
    return value instanceof Date ? value.toISOString().replace(/\.?0*Z/, 'Z') : null;
}
function jsonToDate(json, currentValue) {
    var date = typeof json === 'string' ? new Date(json) : null;
    if (currentValue && date) {
        // compare normalized date strings instead of plain strings
        return currentValue.toISOString() === date.toISOString() ? currentValue : date;
    }
    return date;
}
var BasicType = /** @class */ (function (_super) {
    tslib_1.__extends(BasicType, _super);
    /**
     * Creates a new instance of a native db type
     * @param ref The db ref of this type
     * @param typeConstructor The javascript class of this type
     * @param noResolving Indicates if this type is not the main type of the constructor
     */
    function BasicType(ref, typeConstructor, noResolving) {
        var _this = this;
        var id = ref.indexOf('/db/') === 0 ? ref : "/db/".concat(ref);
        _this = _super.call(this, id, typeConstructor) || this;
        _this.noResolving = !!noResolving;
        return _this;
    }
    Object.defineProperty(BasicType.prototype, "persistenceType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return Type_1.PersistenceType.BASIC;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    BasicType.prototype.toJsonValue = function (state, currentValue) {
        return currentValue === null || currentValue === undefined ? null : this.typeConstructor(currentValue);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    BasicType.prototype.fromJsonValue = function (state, json, currentValue) {
        return json === null || json === undefined ? null : json;
    };
    BasicType.prototype.toString = function () {
        return "BasicType(".concat(this.ref, ")");
    };
    BasicType.Boolean = new /** @class */ (function (_super) {
        tslib_1.__extends(BooleanType, _super);
        function BooleanType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        BooleanType.prototype.fromJsonValue = function (state, json, currentValue) {
            return typeof json === 'string' ? json !== 'false' : _super.prototype.fromJsonValue.call(this, state, json, currentValue);
        };
        return BooleanType;
    }(BasicType))('Boolean', Boolean);
    BasicType.Double = new /** @class */ (function (_super) {
        tslib_1.__extends(DoubleType, _super);
        function DoubleType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DoubleType.prototype.fromJsonValue = function (state, json, currentValue) {
            return typeof json === 'string' ? parseFloat(json) : _super.prototype.fromJsonValue.call(this, state, json, currentValue);
        };
        return DoubleType;
    }(BasicType))('Double', Number);
    BasicType.Integer = new /** @class */ (function (_super) {
        tslib_1.__extends(IntegerType, _super);
        function IntegerType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        IntegerType.prototype.fromJsonValue = function (state, json, currentValue) {
            return typeof json === 'string' ? parseInt(json, 10) : _super.prototype.fromJsonValue.call(this, state, json, currentValue);
        };
        return IntegerType;
    }(BasicType))('Integer', Number);
    BasicType.String = new /** @class */ (function (_super) {
        tslib_1.__extends(StringType, _super);
        function StringType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StringType.prototype.fromJsonValue = function (state, json, currentValue) {
            return _super.prototype.fromJsonValue.call(this, state, json, currentValue);
        };
        return StringType;
    }(BasicType))('String', String);
    BasicType.DateTime = new /** @class */ (function (_super) {
        tslib_1.__extends(DateTimeType, _super);
        function DateTimeType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DateTimeType.prototype.toJsonValue = function (state, value) {
            return dateToJson(value);
        };
        DateTimeType.prototype.fromJsonValue = function (state, json, currentValue) {
            return jsonToDate(json, currentValue);
        };
        return DateTimeType;
    }(BasicType))('DateTime', Date);
    BasicType.Date = new /** @class */ (function (_super) {
        tslib_1.__extends(DateType, _super);
        function DateType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DateType.prototype.toJsonValue = function (state, value) {
            var json = dateToJson(value);
            return json ? json.substring(0, json.indexOf('T')) : null;
        };
        DateType.prototype.fromJsonValue = function (state, json, currentValue) {
            return jsonToDate(json, currentValue);
        };
        return DateType;
    }(BasicType))('Date', Date);
    BasicType.Time = new /** @class */ (function (_super) {
        tslib_1.__extends(TimeType, _super);
        function TimeType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        TimeType.prototype.toJsonValue = function (state, value) {
            var json = dateToJson(value);
            return json ? json.substring(json.indexOf('T') + 1) : null;
        };
        TimeType.prototype.fromJsonValue = function (state, json, currentValue) {
            return typeof json === 'string' ? jsonToDate("1970-01-01T".concat(json), currentValue) : null;
        };
        return TimeType;
    }(BasicType))('Time', Date);
    BasicType.File = new /** @class */ (function (_super) {
        tslib_1.__extends(FileType, _super);
        function FileType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        FileType.prototype.toJsonValue = function (state, value) {
            return value instanceof binding_1.File ? value.id : null;
        };
        FileType.prototype.fromJsonValue = function (state, json, currentValue) {
            if (!json) {
                return null;
            }
            if (currentValue && currentValue.id === json) {
                return currentValue;
            }
            if (state.db) {
                return new state.db.File(json);
            }
            return null;
        };
        return FileType;
    }(BasicType))('File', binding_1.File);
    BasicType.GeoPoint = new /** @class */ (function (_super) {
        tslib_1.__extends(GeoPointType, _super);
        function GeoPointType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GeoPointType.prototype.toJsonValue = function (state, value) {
            return value instanceof GeoPoint_1.GeoPoint ? value.toJSON() : null;
        };
        GeoPointType.prototype.fromJsonValue = function (state, json) {
            return json ? new GeoPoint_1.GeoPoint(json) : null;
        };
        return GeoPointType;
    }(BasicType))('GeoPoint', GeoPoint_1.GeoPoint);
    BasicType.JsonArray = new /** @class */ (function (_super) {
        tslib_1.__extends(JsonArrayType, _super);
        function JsonArrayType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        JsonArrayType.prototype.toJsonValue = function (state, value) {
            return Array.isArray(value) ? value : null;
        };
        JsonArrayType.prototype.fromJsonValue = function (state, json) {
            return Array.isArray(json) ? json : null;
        };
        return JsonArrayType;
    }(BasicType))('JsonArray', Array);
    BasicType.JsonObject = new /** @class */ (function (_super) {
        tslib_1.__extends(JsonObjectType, _super);
        function JsonObjectType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        JsonObjectType.prototype.fromJsonValue = function (state, json, currentValue) {
            return _super.prototype.fromJsonValue.call(this, state, json, currentValue);
        };
        JsonObjectType.prototype.toJsonValue = function (state, value) {
            if (value && value.constructor === Object) {
                return value;
            }
            return null;
        };
        return JsonObjectType;
    }(BasicType))('JsonObject', Object);
    return BasicType;
}(Type_1.Type));
exports.BasicType = BasicType;
//# sourceMappingURL=data:application/json;base64,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